import { ArrowLeft, Compass } from "lucide-react";
import { Link } from "react-router-dom";

export function NotFoundPage() { return <section className="not-found container"><div><span>404</span><Compass /><h1>Этой точки пока нет на карте</h1><p>Проверьте адрес или вернитесь к каталогу стран.</p><Link className="button button-primary" to="/"><ArrowLeft /> На главную</Link></div></section>; }
